export default {
  ELCANO_MASTER: 15,
};



// WEBPACK FOOTER //
// ./src/variables/productTypeIds.js